module.exports = {"530421001":"大街街道","530421101":"江城镇","530421102":"前卫镇","530421103":"九溪镇","530421104":"路居镇","530421201":"安化彝族乡","530421202":"雄关乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530421.json
// module id = 2566
// module chunks = 0